import { LegacyTimelinePost } from './LegacyTimelinePost';

export { LegacyTimelinePost };
export default LegacyTimelinePost;
